
// window.gtag() is defined in index.html
export const safeGtagEvent = (eventName, eventData) => {
  try {
    console.log(`Sending event ${eventName} with data ${JSON.stringify(eventData)}`);
    return window.gtag('event', eventName, eventData);
  } catch (err) {
    console.error(`Failed to post gtag event: ${err}`);
  }
};
